import React from "react"
import { Link } from "@zestia/gatsby-plugin-react-i18next"
import getIntegrations from "@/utils/get-integrations"
import { useTranslation } from "@zestia/gatsby-plugin-react-i18next"

const IntegrationsHighlight = ({
  title,
  integrationsFooterLink,
  description,
  text,
  integrations,
  integrationData,
  light = false,
}) => {
  const { t } = useTranslation()

  return (
    <section
      className={`integrations-highlight__container ${
        light ? "integrations-highlight__container--light" : ""
      }`}
    >
      <div className="col-xs-12 col-sm-10 col-md-6 mb-20">
        {title && <h2>{title}</h2>}

        <p className="p--lg">{description}</p>
      </div>

      <div className="integrations row center-xs container-fluid">
        {getIntegrations(
          integrationData,
          typeof integrations === "string"
            ? integrations.split(",")
            : integrations,
        ).map((integration, i) =>
          integration.slug ? (
            <Link to={`${integration.slug}`} key={integration.title}>
              <div
                className={`col-xs-12 col-sm-6 col-md-3 integration start-xs ${
                  i !== 0 ? "pt-4 sm:pt-0 sm:pl-4" : ""
                }`}
              >
                <div className="integration__tile">
                  <div
                    className={`integration__logo ${
                      integration.icon_color === "ffffff"
                        ? "integration__logo--border"
                        : ""
                    }`}
                    style={{ background: `#${integration.icon_color}` }}
                  >
                    <img
                      src={`/icons/integrations/${integration.image}`}
                      className="integration__image"
                      alt={`${integration.title}`}
                    />
                  </div>
                </div>
                {text && (
                  <div>
                    <strong className="text-link text-link--dark">
                      {integration.title}
                    </strong>
                    <p className="mt-4 integration__text">
                      {integration.short_description}
                    </p>
                  </div>
                )}
              </div>
            </Link>
          ) : integration.external_url ? (
            integration.external_url.startsWith("/") ? (
              <Link to={integration.external_url} key={integration.title}>
                <div
                  className={`col-xs-12 col-sm-6 col-md-3 integration start-xs ${
                    i !== 0 ? "pt-4 sm:pt-0 sm:pl-4" : ""
                  }`}
                >
                  <div className="integration__tile">
                    <div
                      className={`integration__logo ${
                        integration.icon_color === "ffffff"
                          ? "integration__logo--border"
                          : ""
                      }`}
                      style={{ background: `#${integration.icon_color}` }}
                    >
                      <img
                        src={`/icons/integrations/${integration.image}`}
                        className="integration__image"
                        alt={`${integration.title}`}
                      />
                    </div>
                  </div>
                  {text && (
                    <div>
                      <strong className="text-link text-link--dark">
                        {integration.title}
                      </strong>
                      <p className="mt-4 integration__text">
                        {integration.short_description}
                      </p>
                    </div>
                  )}
                </div>
              </Link>
            ) : (
              <a href={integration.external_url} key={integration.title}>
                <div
                  className={`col-xs-12 col-sm-6 col-md-3 integration start-xs ${
                    i !== 0 ? "pt-4 sm:pt-0 sm:pl-4" : ""
                  }`}
                >
                  <div className="integration__tile">
                    <div
                      className={`integration__logo ${
                        integration.icon_color === "ffffff"
                          ? "integration__logo--border"
                          : ""
                      }`}
                      style={{ background: `#${integration.icon_color}` }}
                    >
                      <img
                        src={`/icons/integrations/${integration.image}`}
                        className="integration__image"
                        alt={`${integration.title}`}
                      />
                    </div>
                  </div>
                  {text && (
                    <div>
                      <strong className="text-link text-link--dark">
                        {integration.title}
                      </strong>
                      <p className="mt-4 integration__text">
                        {integration.short_description}
                      </p>
                    </div>
                  )}
                </div>
              </a>
            )
          ) : (
            <div
              className={`col-xs-12 col-sm-6 col-md-3 integration start-xs ${
                i !== 0 ? "pt-4 sm:pt-0 sm:pl-4" : ""
              }`}
              key={integration.title}
            >
              {text && integration.slug && (
                <div>
                  <strong className="text-link text-link--dark">
                    {integration.title}
                  </strong>
                  <p className="mt-4 integration__text">
                    {integration.short_description}
                  </p>
                </div>
              )}
            </div>
          ),
        )}
      </div>

      {integrationsFooterLink && (
        <Link className="integrations-footer-btn" to="/integrations/">
          {t("common.integration-highlight-header-link-default")}
        </Link>
      )}
    </section>
  )
}

export default IntegrationsHighlight
